import React from 'react';
import PropTypes from 'prop-types';
import { NeoDateRangePicker, NeoButton } from '../../../../../components/Common';

const FILTER_OPTIONS = [
    { key: "TODAY", label: "Hoje" },
    { key: "WEEK", label: "Semana" },
    { key: "MONTH", label: "Mês" },
    { key: "ALL", label: "Tudo" },
];

/**
 * AttendanceFilters
 * Renderiza o Header da aba de Frequência e os controles de filtro (botoes e custom range)
 * Migrado para o NeoDateRangePicker do Neo Design System.
 */
const AttendanceFilters = ({
    filter,
    customRange,
    handleFilterChange,
    handleCustomRange
}) => {
    return (
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
            <div className="d-flex align-items-center">
                <div className="avatar-sm me-3 flex-shrink-0">
                    <span 
                        className="avatar-title rounded-circle font-size-22"
                        style={{
                            backgroundColor: '#fef8f3',
                            color: 'var(--color-brand-accent)',
                            border: '1.5px solid rgba(226, 102, 28, 0.15)'
                        }}
                    >
                        <i className="mdi mdi-calendar-check"></i>
                    </span>
                </div>
                <div>
                    <h5 className="mb-1 fw-bold" style={{ color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>Histórico de Frequência</h5>
                    <p className="text-muted mb-0 font-size-13" style={{ fontFamily: 'Outfit, sans-serif' }}>Registro detalhado de presenças e ausências do aluno.</p>
                </div>
            </div>

            <div className="d-flex align-items-center gap-2 flex-wrap" style={{ fontFamily: 'Outfit, sans-serif' }}>
                <div className="d-flex gap-1">
                    {FILTER_OPTIONS.map((opt) => {
                        const isActive = filter === opt.key;
                        return (
                            <NeoButton
                                key={opt.key}
                                variant={isActive ? "primary" : "outline-primary"}
                                size="sm"
                                onClick={() => handleFilterChange(opt.key)}
                                className="neo-filter-search-btn"
                            >
                                {opt.label}
                            </NeoButton>
                        );
                    })}
                </div>

                <NeoDateRangePicker
                    startDate={customRange?.startDate || ""}
                    endDate={customRange?.endDate || ""}
                    onChange={handleCustomRange}
                    size="sm"
                    className="mb-0 neo-daterangepicker-filter"
                    placeholder="Selecione o período..."
                />
            </div>
        </div>
    );
};

AttendanceFilters.propTypes = {
    filter: PropTypes.string.isRequired,
    customRange: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string
    }).isRequired,
    handleFilterChange: PropTypes.func.isRequired,
    handleCustomRange: PropTypes.func.isRequired
};

export default AttendanceFilters;
